import { useThumbnailCardDataList } from './useDataList';
import {
  sharedFilesPageActions,
  sharedFilesPageSelector,
} from '../redux/slicers/sharedFilesPageSlicer';
import { getSharedFilesPageListApi } from '../api/share/share';
import { useEffect, useMemo } from 'react';
import { By_Me_Value, By_Team_Member_Value, With_Me_Value, With_Organisation_Value, With_Team_Member_Value } from '../constants/filters';
import { useUserContext } from '../contexts/UserContext';
import { useDispatch, useSelector } from 'react-redux';
import {
  addUpdateParamsInSequence,
  filterSelector,
  resetSharedFilter,
  selectableMembersCount,
  selectSelectedMembersBy,
  selectSelectedMembersTo,
  selectSharedTo,
  setSharedFilesQueryFilters,
} from '../redux/slicers/filters/filterSlicer';
import { paginatedTeamSelector } from "../redux/slicers/team/paginatedTeamSlicer";

export const useSharedFiles = ({
  requestParams,
  filterByKey,
  defaultBrands,
  defaultSort = '-created_at',
  defaultFilterBy,
  defaultCreatedBy,
  useGlobalSearch,
  api,
} = {}) => {
  const dispatch = useDispatch();
  const { currentUser } = useUserContext();
  const totalMembers = useSelector(selectableMembersCount);
  const sharedTo = useSelector(selectSharedTo);
  const selectedMembersBy = useSelector(selectSelectedMembersBy);
  const selectedMembersTo = useSelector(selectSelectedMembersTo);
  const { isSelectedAllTeam, isSelectedAllMembers } = useSelector(filterSelector);
  const selectedMembers = useSelector((state) => filterSelector(state).members);
  const memberList = useSelector(paginatedTeamSelector);

  useEffect(() => {
    return () => {
      dispatch(resetSharedFilter())
    }
  }, [])

  const handleGetList = () => {
    if (selectedMembers?.length && memberList?.list?.length) {
      let list = [];
      memberList?.list?.map((team) => {
        if (selectedMembers.some(({ id }) => +id === +team?.id)) {
          list.push({
            id: team?.id,
            name: team?.user?.name || team?.user?.first_name,
          });
        }
      });
      return list || [];
    } else {
      return []
    }
  };
  
  const requestParamsCombined = useMemo(() => {
    let shared_to = '';
    let shared_by = '';
    let shared_to_org = '';

    const listToMemmber = [...selectedMembers, ...selectedMembersTo, ...selectedMembersBy]
    
    let shareToTeamMember = handleGetList()
    let shareByTeamMember = []

    listToMemmber?.map((list) => {
      if (!shareToTeamMember?.find((info) => +info?.id === +list?.id)) {
        shareByTeamMember.push(list)
      } 
    })

    if (selectedMembers?.length === 1 && listToMemmber?.[0]?.id === currentUser?.id) {
      if (!shareToTeamMember?.length) {
        shareToTeamMember = [selectedMembers[0]]
        const indexValue = shareByTeamMember.find(({ id }) => id === currentUser?.id)
        if (~indexValue) {
          shareByTeamMember.splice(indexValue,1)
        }
      }
    }

    if (sharedTo === With_Me_Value) {
      shared_to = currentUser.id;
      shared_by = shareByTeamMember?.map((item) => item?.id)?.join(',');
    } else if (sharedTo === By_Me_Value) {
      shared_to = shareToTeamMember?.map((item) => item?.id)?.join(',');
      shared_by = currentUser.id;
    } else if (sharedTo === With_Organisation_Value) {
      shared_to_org = currentUser.organization;
      shared_by = shareByTeamMember?.map((item) => item?.id)?.join(',');
    } else if (sharedTo === With_Team_Member_Value) {
      shared_to = shareToTeamMember?.map((item) => item?.id)?.join(',');
      shared_by = shareByTeamMember?.map((item) => item?.id)?.join(',');
    } else if (sharedTo === By_Team_Member_Value) {
      shared_to = shareToTeamMember?.map((item) => item?.id)?.join(',');
      shared_by = shareByTeamMember?.map((item) => item?.id)?.join(',');
    }

    // if (sharedTo === With_Me_Value) {
    //   shared_to = isAdminOrOwner(currentUser)
    //     ? totalMembers !== selectedMembersTo.length ? selectedMembersTo?.map((item) => item?.id)?.join(',') : ''
    //     : currentUser.id;
    // } else if (sharedTo === By_Me_Value) {
    //   shared_to = !isAdminOrOwner(currentUser)
    //     ? totalMembers !== selectedMembersBy.length ? selectedMembersBy?.map((item) => item?.id)?.join(',') : ''
    //     : currentUser.id;

    //   shared_by = isAdminOrOwner(currentUser)
    //     ? totalMembers !== selectedMembersBy.length ? selectedMembersBy?.map((item) => item?.id)?.join(',') : ''
    //     : currentUser.id;
    // } else if (sharedTo === With_Organisation_Value) {
    //   shared_to_org = currentUser.organization;
    // }

    return {
      shared_to,
      shared_to_org,
      shared_by,
      ...requestParams,
    };
  }, [requestParams, sharedTo, selectedMembersBy, selectedMembersTo, isSelectedAllTeam, isSelectedAllMembers, selectedMembers]);

  useEffect(() => {
    const sharedInfo = {
      shared_to: requestParamsCombined.shared_to,
      shared_to_org: requestParamsCombined.shared_to_org,
      shared_by: requestParamsCombined.shared_by,
    };
    dispatch(addUpdateParamsInSequence({ shared: sharedInfo }));
    dispatch(setSharedFilesQueryFilters(sharedInfo));
  }, [
    requestParamsCombined.shared_to,
    requestParamsCombined.shared_to_org,
    requestParamsCombined.shared_by,
  ]);

  const data = useThumbnailCardDataList({
    selector: sharedFilesPageSelector,
    resetAction: sharedFilesPageActions.resetList,
    getAction: api || getSharedFilesPageListApi,
    requestParams: requestParamsCombined,
    filterByKey,
    defaultBrands,
    defaultSort,
    defaultFilterBy,
    useGlobalFilter: true,
    hookName: 'useRooms',
    defaultCreatedBy,
    useGlobalSearch,
  });

  return data;
};
